import { useState, useRef, useEffect } from "react"
import Svg from "../../shared/_svgs/svg"
import { generateRandomString } from "../../helpers/keys"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import useWindowWidth from "../../hooks/useWindowWidth"

const UniverseSelectionBar = ({ universeSelection, universesSelectText, isMobile }) => {
  const [isSelectorOpen, setIsSelectorOpen] = useState(false)

  const universeSelectorRef = useRef(null)

  useEffect(() => {
    const handleEvent = (event) => {
      //if the current event is not a descendant of the universe selector, close it.
      if (!isDescendantOf(event.target, universeSelectorRef.current)) {
        setIsSelectorOpen(false)
      }
    }
    document.addEventListener("focus", handleEvent, true)

    return () => {
      document.removeEventListener("focus", handleEvent, true)
    }
  }, [])

  function isDescendantOf(child, parent) {
    let node = child.parentNode

    while (node) {
      if (node === parent) {
        return true
      }
      node = node.parentNode
    }

    return false
  }

  const windowWidth = useWindowWidth()

  //if current page isnt registered within a universe,
  //we use this flag along with the mainUniverse property
  //to designate the current page is part of the mainUniverse as a fallback mechanism.
  const shouldFallBackToMainUniverse =
    universeSelection && universeSelection.length > 0 && universeSelection.map((u) => u.currentUniverse).every((cu) => cu === false)

  if (!universeSelection) return null

  return (
    <div className="universe-container">
      <div className="universe-selector universe-selector__bar w--wider">
        <div className="universe-select">
          <input
            tabIndex={windowWidth > 768 ? 0 : -1}
            aria-hidden={windowWidth > 768 ? "false" : "true"}
            type="checkbox"
            onChange={(e) => setIsSelectorOpen(e.target.checked)}
            checked={isSelectorOpen}
            id="universe-dropdown"
          />
          <div ref={universeSelectorRef} className="dropdowncontainer">
            <OutsideClickTrigger onOutsideClick={() => setIsSelectorOpen(false)}>
              <>
                <label
                  htmlFor="universe-dropdown"
                  className={`selector${isSelectorOpen || isMobile ? " open" : " closed"}`}
                  name="Universe Selector"
                  role="combobox"
                  tabIndex={isMobile ? "" : 0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") setIsSelectorOpen(!isSelectorOpen)
                  }}
                  aria-haspopup="listbox"
                  aria-expanded={isSelectorOpen}
                >
                  {universesSelectText}
                  {isMobile ? null : (
                    <span className={`selector-arrow-icon${isSelectorOpen ? " open" : ""}`}>
                      <svg className="svg-icon svg-icon--arrowdownangle">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowdownangle">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                  )}
                </label>
                <ul className="universe-dropdown">
                  {universeSelection.map((universe, index) => (
                    <li key={generateRandomString()}>
                      <a
                        data-property={index}
                        tabIndex={isSelectorOpen || isMobile ? 0 : -1}
                        href={universe.universeRoot}
                        className={`${isMobile ? "mobile " : ""}${universe.currentUniverse ? "active-site" : shouldFallBackToMainUniverse && universe.mainUniverse ? "active-site" : ""}`}
                      >
                        <div className="icon">
                          <Svg iconName={universe.universeIcon} renderContainer={false} />
                        </div>
                        <div className="text">{universe.universeName}</div>
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            </OutsideClickTrigger>
          </div>
        </div>
      </div>
    </div>
  )
}
export default UniverseSelectionBar
